// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"953":"087d3e6b26b43caf","2292":"f81426536daf0b81","6721":"f46dc56e192c7705"}[chunkId] + ".css";
};